export function getShirtQuestionIds(prefix: string) {
  return {
    monthlyYn: `${prefix}-shirts-monthly-yn`,
    month: `${prefix}-shirts-month`,
    poloYn: `${prefix}-shirts-polo-yn`,
  };
}
